import List from './list/Notifications';
import Archive from './notification-archive/NotificationArchive'

export default { List, Archive };